// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"83":"investment","136":"tradeWithUs","177":"home","454":"markets","809":"joinUs","943":"platforms"}[chunkId] + "." + {"83":"524c33b6","136":"acdd9d21","177":"52b3b53c","454":"05d24aa0","809":"c0cd4468","943":"0c01f72e"}[chunkId] + ".css";
};